import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


//----------------------此处开始 每次增加一个项目 需要增加一条引入-----------------------------------------------------
import main from "./routerfile/main"
//import 子项目xx from "./routerfile/子项目路由xx"



//-----------------------------每次有新的子项目增加----------------------------------------------
const projectRouterObj = {
    main,

    // 某项目
}

//-------------------------每次增加 结束--------------------------------------------------


//-------------------以下固定不动--------------------------------------------------------
let projectName = process.env.VUE_APP_Project || "main"

var routers = [];
if (projectName == "all") {
    for (let key in projectRouterObj) {
        console.log(projectRouterObj[key]);
        routers.push(...projectRouterObj[key]);
    }
} else {
    routers = [
        ...main,
        ...projectRouterObj[projectName] || []
    ]
}


export default new Router({

    routes: routers
})